import styled from "styled-components";
import { useSelector } from "react-redux";
import props from "../../redux/props";
import { getUUID } from "../../utility";
import hero from "../../assets/image/career/hero/hero.webp";

const blue = "rgb(0, 79, 139)";

const StyledHero = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(${hero});
  background-size: cover;
  background-position: center center;
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 25px;
`;

const Subtitle = styled.div`
  color: ${blue};
  font-size: 22px;
  text-transform: uppercase;
`;

const Title = styled.div`
  color: ${blue};
  font-size: 60px;
  font-weight: bold;
  text-align: center;
  @media (max-width: 992px) {
    font-size: 32px;
  }
`;

const Subline = styled.div`
  font-size: 22px;
  color: ${blue};
  text-align: center;
`;

const CareerHero = () => {
  const t = useSelector((s) => s[props.TRANSLATION]);

  return (
    <StyledHero>
      <Content>
        <Subtitle>{t.career.hero.subtitle}</Subtitle>
        <div>
          {t.career.hero.title.map((line: string) => (
            <Title key={getUUID()}>{line}</Title>
          ))}
        </div>
        <Subline>{t.career.hero.subline}</Subline>
      </Content>
    </StyledHero>
  );
};

export default CareerHero;
